//List des LOGS achetés
export const LOGS_LIST_REQUESTING = 'LOGS_LIST_REQUESTING'
export const LOGS_LIST_SUCCESS = 'LOGS_LIST_SUCCESS'
export const LOGS_LIST_FAILED = 'LOGS_LIST_FAILED'

export const PAGINATE_LOGS_LIST_REQUESTING = 'PAGINATE_LOGS_LIST_REQUESTING'
export const PAGINATE_LOGS_LIST_SUCCESS = 'PAGINATE_LOGS_LIST_SUCCESS'
export const PAGINATE_LOGS_LIST_FAILED = 'PAGINATE_LOGS_LIST_FAILED'